import src from "IMAGE";
export default { src, width: 789, height: 196, blurWidth: 0, blurHeight: 0};
